<template>
  <div class="book-v-nav">
    <button class="viewer-nav-btn" id="previous">←</button>
    <button class="viewer-nav-btn" id="next">→</button>
    <button class="viewer-nav-btn" id="zoom-in">⊕</button>
    <button class="viewer-nav-btn" id="zoom-out">⊖</button>
    <button class="viewer-nav-btn" id="fullscreen">➚</button>
    <div  id="viewer-image" />
  </div>
</template>
<script>
import OpenSeadragon from "openseadragon";
window.OpenSeadragon = OpenSeadragon;
export default {
  name: "BookViewer",
  props: {
    imgObj: {
      type: Array
    }
  },
  data() {
    return {
      viewer: null
    };
  },
  mounted() {
   // this.initViewer();
    
  },

  methods: {
    changeImages(startingPoint) {
      var myImages = this.$store.state.aioImages.imageitems
    
      if (this.viewer){
        this.viewer.close()
        // prevent colored background when opening second image
        this.viewer.drawer.clear()
        this.viewer.open(myImages)
        this.viewer.goToPage(startingPoint)
      }
      else {
          if(myImages){ 
            this.viewer = OpenSeadragon({
              zoomInButton:   "zoom-in",
              zoomOutButton:  "zoom-out",
              homeButton:     "home",
              fullPageButton: "fullscreen",
              previousButton: "previous",
              nextButton: "next",
              id: "viewer-image",
              animationTime: 0.4,
              prefixUrl: "//openseadragon.github.io/openseadragon/images/",
              showNavigator: true,
              sequenceMode: true,
              //crossOriginPolicy: 'Anonymous',
              tileSources: myImages,
              initialPage: startingPoint
            }); 
            this.viewer.goToPage(startingPoint)
          }  
      }
    },
    initViewer() {    
      //var myImages = this.$store.state.aioImages.imageitems 
      var myImages = [] 

/*
      // image array example
      var source = [
        {
          type: "image",
          url:
            "http://mssc.ch/SLA-FD-A-a40ix/SLA-FD-A-a40ix_197.jpg"
        },
        {
          type: "image",
          url:
            "http://mssc.ch/SLA-FD-A-a40ix/SLA-FD-A-a40ix_196.jpg"
        },
        {
          type: "image",
          url:
            "http://mssc.ch/SLA-FD-A-a40ix/SLA-FD-A-a40ix_195.jpg",         
        }
      ];

*/

      if(this.viewer) {this.viewer.destroy()}    
      this.viewer = OpenSeadragon({
        id: "viewer-image",
        animationTime: 0.4,
        prefixUrl: "//openseadragon.github.io/openseadragon/images/",
        showNavigator: true,
        sequenceMode: true,
        //crossOriginPolicy: 'Anonymous',
        tileSources: myImages 
      });
 
    }
  }
};
</script>

<style lang="scss">
.book-v-nav {
  button {
    border: none;
    color:white;
    background:transparent;
  }
 .viewer-nav-btn{
    font-family: "icons";
    font-size: 1.5rem;
    font-weight: 100;
    margin:0 0 0 1rem;   
 } 
}

#overlay1.filter {
  border: 4px solid green;
  background-color: green;
}
</style>
